import { VerificationPageLoader } from 'src/pages/VerificationPage/components/VerificationPageLoader';

const VerificationPageRetryablePartnerFlowContent = () => {
  return <VerificationPageLoader/>;
};
export default VerificationPageRetryablePartnerFlowContent;
